import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const PrivateRoute = ({ children, roles = [], permiso = null }) => {
    const { user, loading, can } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-gray-500 text-sm">Cargando...</div>
            </div>
        );
    }

    if (!user) return <Navigate to="/login" replace />;

    // Verificar por rol hardcodeado
    if (roles.length > 0 && !roles.includes(user.role_slug)) {
        return <Navigate to="/dashboard" replace />;
    }

    // Verificar por permiso de BD
    if (permiso && !can(permiso[0], permiso[1])) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default PrivateRoute;
